import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import { LinkTabNavHorizontal } from '../../components';
import classNames from 'classnames';

import css from './UserNav.module.css';

const UserNav = props => {
  const { className, rootClassName, selectedPageName } = props;
  const classes = classNames(rootClassName || css.root, className);

  const tabs = [
    {
      text: <FormattedMessage id="UserNav.subscriptionsPage" />,
      selected: selectedPageName === 'ManageSubscriptionsPage',
      disabled: false,
      linkProps: {
        name: 'ManageSubscriptionsPage',
      },
    },
    {
      text: <FormattedMessage id="UserNav.watchlistPage" />,
      selected: selectedPageName === 'WatchlistPage',
      disabled: false,
      linkProps: {
        name: 'WatchlistPage',
      },
    },
    {
      text: <FormattedMessage id="UserNav.calendarPage" />,
      selected: selectedPageName === 'CalendarPage',
      disabled: false,
      linkProps: {
        name: 'CalendarPage',
      },
    },
    {
      text: <FormattedMessage id="UserNav.inboxPage" />,
      selected: selectedPageName === 'AudienceConversationsPage',
      disabled: false,
      linkProps: {
        name: 'AudienceConversationsPage',
      },
    },
  ];

  return (
    <LinkTabNavHorizontal className={classes} tabRootClassName={css.tab} tabs={tabs} skin="dark" />
  );
};

UserNav.defaultProps = {
  className: null,
  rootClassName: null,
};

const { string } = PropTypes;

UserNav.propTypes = {
  className: string,
  rootClassName: string,
  selectedPageName: string.isRequired,
};

export default UserNav;
